import {easepick} from "@easepick/core";
import {LockPlugin} from "@easepick/lock-plugin";
import {RangePlugin} from "@easepick/range-plugin";
import _ from 'lodash';
import moment from 'moment';

class Datepicker {
    constructor(config) {
        this.config = Object.assign({
            scope: '[data-datepicker]'
        }, config);

        this.$scope = $(this.config.scope);

        if (this.$scope.length > 0) {
            this.init();
        }
    }

    destroyExisting($element) {
        let easepick = $element.data('easepick');
        if (easepick) {
            easepick.destroy();
        }
    }

    init() {
        this.$scope.each((index, element) => {
            let $element = $(element);
            this.destroyExisting($element);
            let settings = _.merge({
                element: element,
                css: [
                    'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
                ],
                LockPlugin: {
                    filter: this.filterDates.bind(this, $element)
                },
                plugins: [
                    LockPlugin,
                    RangePlugin
                ]
            }, $element.data('datepicker'))

            if ($element.attr('min')) {
                settings.LockPlugin.minDate = $element.attr('min');
            }

            let $extra = $(settings.RangePlugin.elementEnd);

            let datepicker = new easepick.create(settings);

            if ($extra.val()) {
                datepicker.gotoDate($extra.val());
            } else if ($element.attr('min')) {
                datepicker.gotoDate($element.attr('min'));
            }

            datepicker.on('select', this.onSelect.bind(this, $element, $extra, settings));
            datepicker.on('render', this.onRender.bind(this));
            datepicker.on('view', this.onRender.bind(this));
            datepicker.trigger('render');

            $element.data('easepick', datepicker);
        });
    }

    onSelect($element, $extra, settings, event) {
        $element[0].dispatchEvent(new Event('input'));
        $extra[0].dispatchEvent(new Event('input'));
    }

    onRender(event) {
        let $calendar = $(event.target);

        $calendar.find('.day.locked').each((index, cell) => {
            let $cell = $(cell);
            if (moment($cell.data('time')).weekday() === 0) {
                return;
            }
            $(cell).addClass('custom-disabled');
        })
    }

    filterDates($element, date) {
        let dates = $element.data('blocked');

        if(!dates) {
            return;
        }

        let compare = moment(date).format('YYYY-MM-DD');
        return dates.includes(compare) || date.getDay() == 0;
    }
}

export default Datepicker;
